/**
 * SheetGrabber — ручка-«хваталка» вверху мобильных bottom-шитов. Единый вид во
 * всех шитах приложения; нижний отступ задаётся className (по умолчанию mb-3.5).
 */

import {cn} from '@lib/utils';

export const SheetGrabber = ({className}: {className?: string}) => (
  <div className={cn('mx-auto mb-3.5 h-[5px] w-10 rounded-full bg-skr-grip', className)} />
);
